import { Directive } from '@angular/core';

import { BaseComponent } from '~components/abstractions/base.component';

@Directive()
export abstract class BaseSidebarComponent extends BaseComponent {
    data?: any;

    onClose(): void {}
}
